import f from "./internal/_arrayReduce.mjs";
import i from "./internal/_curry2.mjs";
import n from "./internal/_dispatchable.mjs";
import p from "./internal/_filter.mjs";
import u from "./internal/_isObject.mjs";
import _ from "./internal/_xfilter.mjs";
import a from "./keys.mjs";
var j = /* @__PURE__ */ i(
  /* @__PURE__ */ n(["fantasy-land/filter", "filter"], _, function(t, r) {
    return u(r) ? f(function(m, o) {
      return t(r[o]) && (m[o] = r[o]), m;
    }, {}, a(r)) : (
      // else
      p(t, r)
    );
  })
);
export {
  j as default
};
